import React, { useState } from "react";
import { FlexBox, Option } from "../../primitives";
import {
  LabelStyled,
  PrimaryButton,
  StyledInput,
  StyledSelect,
} from "../../common/common.style";
import {
  CardToUploadStatusCardTraderEnum,
  CardToUploadStatusCardMarketEnum,
} from "magic-shared-types";

interface FiltersTableProps {
  statusCt?: CardToUploadStatusCardTraderEnum;
  statusCm?: CardToUploadStatusCardMarketEnum;
  onStatusCtChange: (value: CardToUploadStatusCardTraderEnum) => void;
  onStatusCmChange: (value: CardToUploadStatusCardMarketEnum) => void;
  page: number;
  onPageChange: (value: number) => void;
  total: number;
  pageSize: number;
  setName: (arg1: string) => void;
}

export const FiltersTable: React.FC<FiltersTableProps> = ({
  statusCt,
  statusCm,
  onStatusCtChange,
  onStatusCmChange,
  page,
  onPageChange,
  total,
  pageSize,
  setName,
}) => {
  const [localName, setLocalName] = useState("");
  const totalPages = Math.ceil(total / pageSize);

  return (
    <FlexBox
      css={{
        padding: 16,
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        gap: 20,
      }}
    >
      <FlexBox css={{ gap: 10, alignItems: "center" }}>
        <StyledInput
          type="text"
          value={localName}
          onChange={(e) => {
            setLocalName(e.target.value);
          }}
          onBlur={() => {
            setName(localName);
          }}
          placeholder="Search by name"
          css={{ width: 200 }}
        />
        <LabelStyled>Status CT:</LabelStyled>
        <StyledSelect
          value={statusCt}
          onChange={(e) => {
            onPageChange(1);
            onStatusCtChange(
              e.target.value as CardToUploadStatusCardTraderEnum
            );
          }}
          css={{ width: 100 }}
        >
          <Option value="">All</Option>
          <Option value={CardToUploadStatusCardTraderEnum.PENDING}>
            PENDING
          </Option>
          <Option value={CardToUploadStatusCardTraderEnum.SUCCESS}>
            SUCCESS
          </Option>
          <Option value={CardToUploadStatusCardTraderEnum.FAILED}>
            FAILED
          </Option>
        </StyledSelect>

        <LabelStyled>Status CM:</LabelStyled>
        <StyledSelect
          value={statusCm}
          onChange={(e) => {
            onPageChange(1);
            onStatusCmChange(
              e.target.value as CardToUploadStatusCardMarketEnum
            );
          }}
          css={{ width: 200 }}
        >
          <Option value="">All</Option>
          <Option value={CardToUploadStatusCardMarketEnum.PENDING}>
            PENDING
          </Option>
          <Option value={CardToUploadStatusCardMarketEnum.SUCCESS}>
            SUCCESS
          </Option>
          <Option value={CardToUploadStatusCardMarketEnum.FAILED}>
            FAILED
          </Option>
          <Option value={CardToUploadStatusCardMarketEnum.NOT_SUPPORTED}>
            NOT SUPPORTED
          </Option>
        </StyledSelect>
      </FlexBox>

      {totalPages ? (
        <FlexBox style={{ marginTop: 12, alignItems: "center" }}>
          <PrimaryButton
            disabled={page === 1}
            isDisabled={page === 1}
            onClick={() => onPageChange(Math.max(page - 1, 1))}
            css={{ width: 50 }}
          >
            Prev
          </PrimaryButton>
          <LabelStyled style={{ margin: "0 10px" }}>
            Page {page} / {totalPages}
          </LabelStyled>
          <PrimaryButton
            disabled={page >= totalPages}
            isDisabled={page >= totalPages}
            onClick={() => onPageChange(page + 1)}
            css={{ width: 50 }}
          >
            Next
          </PrimaryButton>
        </FlexBox>
      ) : null}
    </FlexBox>
  );
};
